"use client";
import dynamic from 'next/dynamic';
import { Suspense } from 'react';

const FeaturesSection = dynamic(() => import('@/components/home-features-section'), { ssr: false });
const PartnersSection = dynamic(() => import('@/components/partners-section'), { ssr: false });
const StatsSection = dynamic(() => import('@/components/home-stats-section'), { ssr: false });
const AnimatedBackground = dynamic(() => import('@/components/animated-background'), { ssr: false });

export default function HomeClientSections() {
    return (
        <>
            <AnimatedBackground />
            <Suspense fallback={null}>
                <FeaturesSection />
                <PartnersSection />
                <StatsSection />
            </Suspense>
        </>
    );
} 